<template>
  <div
    v-if="catalogPackageSampleImagesSorted.length > 0"
    class="letter-jacket-sample-images"
  >
    <div class="row hidden-xs hidden-sm hidden-md">
      <div class="col-lg-2">
        <letter-jacket-sample-images-nav
          :sample-images="catalogPackageSampleImagesSorted"
          :selected-image-index="selectedImageIndex"
          class="sample-images__top"
          @image-clicked="handleImageClick"
        />
      </div>
      <div class="col-lg-9">
        <img
          v-if="selectedSampleImage"
          :src="selectedSampleImage"
          class="responsive-img"
        >
      </div>
    </div>
    <div class="row hidden-lg">
      <div class="col-xs-10 col-xs-offset-1">
        <img
          v-if="selectedSampleImage"
          :src="selectedSampleImage"
          class="responsive-img letter-jacket-sample-images__selected-image"
        >
      </div>
      <div class="col-xs-10 col-xs-offset-1">
        <letter-jacket-sample-images-nav
          :sample-images="catalogPackageSampleImagesSorted"
          :selected-image-index="selectedImageIndex"
          class="sample-images__bottom"
          @image-clicked="handleImageClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { orderBy, take } from 'lodash'

import GoogleAnalytics from '@Shared/lib/google-analytics'
import LetterJacketSampleImagesNav from './LetterJacketSampleImagesNav'

export default {
  name: 'LetterJacketSampleImages',
  components: {
    LetterJacketSampleImagesNav
  },
  props: {
    model: { type: Object, default: null, required: true }
  },
  data () {
    return {
      selectedImageIndex: 0
    }
  },
  computed: {
    catalogPackageSampleImagesSorted () {
      return take(orderBy(this.model.CatalogPackageSampleImageUrls, 'ZOrder'), 5)
    },
    selectedSampleImage () {
      if (this.catalogPackageSampleImagesSorted.length > 0) {
        return this.catalogPackageSampleImagesSorted[this.selectedImageIndex]
      }

      return null
    }
  },
  methods: {
    handleImageClick (selectedImageIndex) {
      GoogleAnalytics.trackEvent(
        'Package Sample Image',
        'click',
        (selectedImageIndex + 1)
      )
      this.selectedImageIndex = selectedImageIndex
    }
  }
}
</script>

<style lang="scss" scoped>
.letter-jacket-sample-images {
  margin-bottom: 40px;

  &__selected-image {
    border: 1px solid #757575;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/LetterJacketSampleImages/LetterJacketSampleImages.vue